import { DATA_SOURCE_METRIC_KEY_JOINER, FLATTEN_METRICS_NAMES_MAPPING } from '../constants';

export function generateDataSourceMetricKey(dataSourceKey: string, metricKey: string): string {
  return dataSourceKey + DATA_SOURCE_METRIC_KEY_JOINER + metricKey;
}

export function analyseDataSourceMetricKey(dataSourceMetricKey: string): {
  dataSourceKey: string;
  metricKey: string;
} {
  const result = {
    dataSourceKey: '',
    metricKey: '',
  };
  if (typeof dataSourceMetricKey !== 'string') return result;
  const res = dataSourceMetricKey.split(DATA_SOURCE_METRIC_KEY_JOINER);
  result.dataSourceKey = res[0] || '';
  result.metricKey = res[1] || '';
  return result;
}

export function generateMetrics(dataSourcesMetrics: any): { text: string; value: string }[] {
  const metrics: { text: string; value: string }[] = [];
  if (Object.prototype.toString.call(dataSourcesMetrics) !== '[object Object]') return metrics;
  const dataSourcesKeys = Object.keys(dataSourcesMetrics);
  for (const dataSourceKey of dataSourcesKeys) {
    const dataSourceMetricsKeys = dataSourcesMetrics[dataSourceKey];
    if (!Array.isArray(dataSourceMetricsKeys)) continue;
    for (const metricKey of dataSourceMetricsKeys) {
      if (!metricKey) continue;
      const dataSourceMetricKey = generateDataSourceMetricKey(dataSourceKey, metricKey);
      metrics.push({
        text: FLATTEN_METRICS_NAMES_MAPPING[dataSourceMetricKey] || dataSourceMetricKey || '',
        value: dataSourceMetricKey,
      });
    }
  }
  return metrics;
}

export function getDataSourcesAndMetricsForReq(dataSourceMetricsKeys: string[]): {
  dataSourcesKeys: string[];
  metricsKeys: string[];
} {
  const result: {
    dataSourcesKeys: string[];
    metricsKeys: string[];
  } = {
    dataSourcesKeys: [],
    metricsKeys: [],
  };
  if (!Array.isArray(dataSourceMetricsKeys)) return result;
  for (const dataSourceMetricKey of dataSourceMetricsKeys) {
    const { dataSourceKey, metricKey } = analyseDataSourceMetricKey(dataSourceMetricKey);
    if (!result.dataSourcesKeys.includes(dataSourceKey)) {
      result.dataSourcesKeys.push(dataSourceKey);
    }
    if (!result.metricsKeys.includes(metricKey)) {
      result.metricsKeys.push(metricKey);
    }
  }
  return result;
}
